import { AxiosTrackingData } from './AxiosTrackingData'
import { TrackingFactory } from '@/Domain/Tracking/TrackingFactory'
import { Tracking } from '@/Domain/Tracking/Tracking'
import { Orde, Location, Fase, IsolatesMode, Mountain, Owner, Surface, Taxes } from '@/Domain/Tracking'
import { BatchId } from '@/Domain/Batch'
import { AxiosMadeiristaData } from './AxiosMadeiristaData'
import { Lumberjack, NameLumberJack, Ofert, State } from '@/Domain/Tracking/Lumberjacks'
import { AccountId } from '@/Domain/Account'

export class AxiosTrackingFactory implements TrackingFactory<AxiosTrackingData> {
  makeTracking (data: AxiosTrackingData): Tracking {
    const lumberjacks = this.parseLumberJacks(data.offers)
    const trackingItem = new Tracking(
      data.order === null ? null : new Orde(data.order),
      new BatchId(data.batchId, data.recordId),
      new Fase(data.status),
      new IsolatesMode(data.batchType),
      new Mountain(data.batchMount),
      new Owner(data.batchOwner),
      new Location(data.batchCounty),
      new Surface(data.batchSurface),
      new Taxes(data.batchAppraisal),
      lumberjacks
    )
    return trackingItem
  }

  private parseLumberJacks (offers: AxiosMadeiristaData[]): Lumberjack[] {
    const lumberjacks: Lumberjack[] = []
    for (const item of offers) {
      lumberjacks.push(this.parseSingleLumberjack(item))
    }
    return lumberjacks
  }

  private parseSingleLumberjack (offer: AxiosMadeiristaData): Lumberjack {
    return new Lumberjack(
      new NameLumberJack(offer.name),
      new AccountId(offer.nif),
      offer.offer === null ? null : new Ofert(offer.offer),
      new State(offer.status)
    )
  }
}
